import classNames from "classnames";
import React from "react";
import styles from "./widgetButton.css";

export interface Props {
  onClick?: () => void;
  disabled?: boolean;
  type?: ButtonType;
  fullWidth?: boolean;
  buttonStyle?: StyleType;
  small?: boolean;
  icon?: string;
  id?: string;
}

type StyleType = "primary" | "secondary" | "secondary orange" | "tertiary" | "plain" | "mainOrg" | "dynamicSuggestion" ;
type ButtonType = "button" | "submit" | "reset" | undefined;

export class WidgetButton extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props);
  }

  getStyle(buttonStyle?: StyleType): string {
    switch (buttonStyle) {
      case "primary":
        return styles.primary;
      case "secondary":
        return styles.secondary;
      case "secondary orange":
        return styles["secondary-orange"];
      case "tertiary":
        return styles.tertiary;
      case "plain":
        return styles.plain;
      case "mainOrg":
        return styles["main-org"];
      case "dynamicSuggestion":
        return styles["dynamic-suggestion"];
      default:
        return styles.primary;
    }
  }

  render() {
    const buttonClass = classNames(styles["widget-button"], this.getStyle(this.props.buttonStyle), {
      [styles["full-width"]]: this.props.fullWidth,
      [styles.small]: this.props.small,
      [styles["icon-only"]]: !this.props.children
    });

    return (
      <button
        type={this.props.type}
        onClick={this.props.onClick}
        disabled={this.props.disabled}
        className={buttonClass}
        id={this.props.id}
      >
        {this.props.icon && (
          <div
            className={classNames(styles.icon, { [styles["margin-right"]]: !!this.props.children })}
          >
            <i className={this.props.icon} />
          </div>
        )}
        <div className={styles.text}>{this.props.children}</div>
      </button>
    );
  }
}
